import React from 'react';
import {Col, Row} from 'react-bootstrap';

import {StreamBankChartLegendItemIcon} from "./StreamBankChartLegendItemIcon";
import {StreamBankChartLegendItemHelpIcon} from "./StreamBankChartLegendItemHelpIcon";

export function StreamBankChartLegendItem(props) {
    if(!props.DataSet) {
        return null;
    }
    
    let words = props.DataSet.label.split(' ');
    const firstWord = words.shift();
    const remainingWords = words.join(' ');

    return <Row className="sb-chart-legend-item">
        <Col xs={12} className={"sb-chart-legend-item-text-column" + (props.Enabled ? "" : " disabled")} onClick={() => { props.OnClick(props.DataSet.label); }}>
            <StreamBankChartLegendItemIcon DataSet={props.DataSet} />

            <span className={"legend-label"} style={{color: props.DataSet.borderColor}}>
                <span>{firstWord}</span> <span style={{display: 'inline-block', breakInside: 'avoid'}}>{remainingWords}</span>
            </span>

            <StreamBankChartLegendItemHelpIcon DataSet={props.DataSet}
                                               EnvironmentalBenefit={props?.EnvironmentalBenefit}
            />
        </Col>
    </Row>;
};
